import React from 'react';

const Contact = () => (
  <div className="max-w-3xl mx-auto p-8">
    <h1 className="text-3xl font-bold mb-4">Contact & Support</h1>
    <p className="mb-4">
      Need help or have feedback? Email us at <a href="mailto:support@tailrd.com" className="text-blue-600 underline">support@tailrd.com</a> and we'll get back to you as soon as possible.
    </p>
  </div>
);

export default Contact;
